import { REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import type { CancellationRefundSnapshot } from '@/types/pages/cancellationConfirm'

export const fetchCancellationOrderDetails = async (
  tripId: string,
  cancellationId: string,
): Promise<CancellationRefundSnapshot> => {
  try {
    const URL = `/orders/${tripId}/cancel-info/${cancellationId}`
    const response = await baseFetch<CancellationRefundSnapshot>({
      url: URL,
      method: REQUEST_METHODS.GET,
    })
    if (response) {
      return response
    }
    return Promise.reject()
  } catch (e) {
    console.log(e)
    return Promise.reject(e)
  }
}
